module.exports = __webpack_public_path__ + "img/title.d302d9ce.svg";